// Configuration for each user
const config = {
  DISTRICT_ADMIN: {
    isTeacher: true,
    useSumerian: true,
    inactivityTrack: true,
    inactivityTime: 120000,//2 minutes
    interventionTimeout: 7200,
    enableAudioRecording: false,//TODO: Do we need to record audio for the teacher app?
    useNav: false,
    useMenu: false,
    enableCurrentWordHighlight: true,
  },
  SCHOOL_ADMIN: {
    isTeacher: true,
    useSumerian: true,
    inactivityTrack: true,
    inactivityTime: 120000,//2 minutes
    interventionTimeout: 4200,
    enableAudioRecording: false,//TODO: Do we need to record audio for the teacher app?
    useNav: false,
    useMenu: false,
    enableCurrentWordHighlight: true,
  },
  teacher: {
    isTeacher: true,
    useSumerian: true,
    inactivityTrack: true,
    inactivityTime: 120000,//2 minutes
    interventionTimeout: 4200,
    enableAudioRecording: false,//TODO: Do we need to record audio for the teacher app?
    useNav: false,
    useMenu: false,
    enableCurrentWordHighlight: true,
  },
  student: {
    useSumerian: true,
    interventionTimeout: 4200,
    fastReaderPauseTime: 7700,
    mediumReaderPauseTime: 7100,
    beginnerPauseTime: 7200,
    giveUpLength: 12000,
    enableAudioRecording: true,
    useNav: false,
    useMenu: false,
    enableInterventions: true,
    ignoreNoiseWords: true,
    enableCurrentWordHighlight: true,
    assessmentMode: false,
    enableAssessmentTimer: false,
    assessmentTime: 240000,
    numMatchWords: 2,
    matchWindow: 5,
    separateByComma: true,
    separateByBreakTag: false,
    separateByProsodyTag: false,
  },
  studentTest: {
    useSumerian: true,
    interventionTimeout: 4200,
    fastReaderPauseTime: 3700,
    mediumReaderPauseTime: 4100,
    beginnerPauseTime: 5200,
    giveUpLength: 12000,
    enableAudioRecording: true,
    useNav: true,
    useMenu: true,
    test: true,
    assessmentMode: true,
    enableAssessmentTimer: true,
    assessmentTime: 240000,
    numMatchWords: 2,
    matchWindow: 8,
  },
  readAloud: {
    isReadAloud: true,
    isNotInteractive: true,
    isActivityTrackerDisabled: true,
    useSumerian: true,
    squashedStory: false,
    //This is the order of evaluation of the "separateBy" flags:
    //1.separateByComma, 2.separateByBreakTag, 3.separateByProsodyTag
    //If none are true then we let Polly handle the breaks.
    separateByComma: false,
    separateByBreakTag: true,
    separateByProsodyTag: false,
    breakTime: 0.25,
    prosodyRate: "x-slow",
    interventionTimeout: 4200,
    enableInterventions: false,
    enableAudioRecording: false,
    enableCurrentWordHighlight: true,
    disableWordInterventions: true,
    useNav: false,
    useMenu: false,
  },
  studentHome: {
    useSumerian: true,
    interventionTimeout: 4200,
    enableAudioRecording: false,
    studentHome: true,
    useNav: false,
    useMenu: false,
  },
  activities: {
    useSumerian: true,
    interventionTimeout: 4200,
    enableAudioRecording: false,
    studentSearch: true,        // TODO make an enum for reader content rather than these booleans
    useNav: false,
    useMenu: false,
  },
  reports: {
    useSumerian: true,
    interventionTimeout: 4200,
    enableAudioRecording: false,
    studentSearch: false,
    useNav: false,
    useMenu: false,
  },
  assessment: {
    useSumerian: true,
    interventionTimeout: 4200,
    fastReaderPauseTime: 3700,
    mediumReaderPauseTime: 4100,
    beginnerPauseTime: 5200,
    enableAudioRecording: true,
    enableInterventions: false,
    enableAssessmentTimer: true,
    assessmentTime: 240000,
    ignoreNoiseWords: false,
    assessmentMode: true,
    enableCurrentWordHighlight: false,
    disableWordInterventions: true,
    developerMode: false,                  //Use this to streamline irritating stuff like long speechs from Amira
    showSessionInHeader: false,
    useNav: false,
    useMenu: false,
    numMatchWords: 2,
    matchWindow: 8,
  },
  studentSearch: {
    numberOfActivitiesPerStudent: 1,
  }
}

module.exports = config;